<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import VideoRecordingInteractionImpl from './videoRecordingInteraction/VideoRecordingInteractionImpl.svelte';

    let {
        itemIdentifier,
        responseIdentifier,
        properties = {},
        typeIdentifier = 'videoRecordingInteraction',
        prompt,
        role,
        ariaAttrs = {},
        language,
        id,
        classes = '',
        dir,
        dataAttrs = {},
        disabled = false,
        timeout = 60 * 1000,

        ...restProps
    } = $props();
</script>

<VideoRecordingInteractionImpl
    {...restProps}
    {itemIdentifier}
    {responseIdentifier}
    {properties}
    {typeIdentifier}
    {prompt}
    {role}
    {ariaAttrs}
    {language}
    {id}
    {classes}
    {dir}
    {dataAttrs}
    {disabled}
    {timeout} />
